module.exports = __webpack_public_path__ + "static/img/tab2q.c91761a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab2q.png
// module id = F89j
// module chunks = 1